import apiClient from '@/shared/utils/axios';

export interface UploadLinkEntry {
  url: string;
  key: string;
}

class CloudflareAPI {
  async getUploadLinks(
    files: { path: string; contentType: string }[]
  ): Promise<UploadLinkEntry[]> {
    try {
      const response = await apiClient.post<UploadLinkEntry[]>(
        '/dooh_api/cloudflare/v1/upload-link',
        { files }
      );

      const entries: UploadLinkEntry[] = response.data;
      if (!Array.isArray(entries) || entries.length !== files.length) {
        throw new Error('Invalid response from upload-link API');
      }

      return entries;
    } catch (error) {
      console.error('Error getting upload links:', error);
      throw error;
    }
  }
}

export const cloudflareAPI = new CloudflareAPI();
